import { render, staticRenderFns } from "./MasterFieldCreate.vue?vue&type=template&id=bc27c5d6&"
import script from "./MasterFieldCreate.vue?vue&type=script&lang=ts&"
export * from "./MasterFieldCreate.vue?vue&type=script&lang=ts&"
import style0 from "./MasterFieldCreate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports